export const reportResponses = (state = {}, action) => {
  switch (action.type) {
    case 'UPDATE_REPORT_CONTENT': {
      if (!action.payload) return {};
      return {
        ...state,
        [action.payload.key]: action.payload,
      };
    }
    default:
      return state;
  }
};
